import React, { useState, useEffect } from 'react'

//Dependencies.
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';

//Slices.
  //Functions.
  import { allVideos } from '../../../slices/allVideosSlice';
  
import "./MembersStatsComponents.styles.css";

const MembersStatsComponent = () => {
  const [totalRecord, setTotalRecord] = useState({ wins: 0, losses: 0, ties: 0, winPct: 0 });
  const videos = useSelector(allVideos);

  useEffect(() => {
    Object.values(videos).forEach(val => setTotalRecord(prvTotalRecord => ({
      ...prvTotalRecord,
      wins: prvTotalRecord.wins + val.record.wins,
      losses: prvTotalRecord.losses + val.record.losses,
      ties: prvTotalRecord.ties + val.record.ties
    })));

    setTotalRecord(prvTotalRecord => ({
      ...prvTotalRecord,
      winPct: (prvTotalRecord.wins + prvTotalRecord.losses + prvTotalRecord.ties > 0) ? (prvTotalRecord.wins) / (prvTotalRecord.wins + prvTotalRecord.losses + prvTotalRecord.ties) : 0
    }))
    return () => {
      
    };
  }, []);

  return (
    <Container className='memberStats'>
      {
        Object.values(videos).length ?
          <div>
            <h3>TOTAL WINS: <span style={{color: 'crimson'}}>{ totalRecord.wins }.</span></h3>
            <h3>TOTAL LOSSES: <span style={{color: 'crimson'}}>{ totalRecord.losses }.</span></h3>
            <h3>TOTAL TIES: <span style={{color: 'crimson'}}>{ totalRecord.ties }.</span></h3>
            <h3>CURRENT WIN PCT: <span style={{color: 'crimson'}}>{ totalRecord.winPct }.</span></h3>
          </div>
          :
          <div style={{textAlign: "center"}}>
            <h1>You need to have some videos up to have stats. You have <em className='text-danger'>NO VIDEOS</em>!!!</h1>
          </div>
      }
    </Container>
  )
}

export default MembersStatsComponent